import { StyleSheet } from 'react-native';

export default StyleSheet.create({
  headingText: {
    fontFamily: 'Lato',
    fontWeight: "700",
    fontSize: 28,
  },
  heading1: {
   fontFamily: 'Lato',
   fontWeight: "700",
   fontSize: 22,
 },
 heading2: {
   fontFamily: 'Lato',
   fontWeight: "700",
   fontSize: 19,
 },
 heading3: {
   fontFamily: 'Lato',
   fontWeight: "400",
   fontSize: 17,
 },
 TextCenter:{
     textAlign:"center"
 },
  container: {
    marginTop: 152,
  },
  headingWrapper: {
    alignSelf: 'center',
    alignItems:'center'
  },
  headingTextWrapper: {
    textAlign: 'center',
  },
  visionWrapper:{
    marginTop:175,
   alignItems:'center',
   justifyContent:'center'
},
visionSubTextWrapper:{
   marginTop: 52,
   alignItems: 'center',
   justifyContent: 'center',
 },
 saperaterWrapper: {
   marginVertical: 50,
 },
 saperator: {
   height: 0.5,
   width:"100%",
   backgroundColor: '#6d6d6d',
 },
 valuesWrapper:{
   marginBottom: 85,
   alignItems:'center'
 },

sectionWrapper: {
   marginBottom: 49,
   alignItems:'center'
 },
 section1: {
   marginBottom: 28,
   textAlign:'center'
 },
 section2: {
   marginBottom: 36,
   textAlign:'center'
 },
 manifastoWrapper:{
   marginTop: 107,
   marginBottom: 88,
   alignItems:"center"
},
manifestoText:{
   textAlign:"center"
},
videoWrapper:{
  width: 349,
  height: 241,
  borderWidth:0.5,
  borderColor: "#000000",
  borderRadius: 9,
  padding:9,
  backgroundColor: "transparent",
  marginTop:73
},
cardWrapper: {
   flexDirection: 'column',
   justifyContent: 'space-between',
   alignItems:'center',
 },
 piramidWrapper:{
  justifyContent:'center',
  alignItems: "center",
  marginBottom:67
   },
 cardSection:{
    marginTop: 61
 },
 formWrapper: {
   alignSelf: 'center',
   width: "100%",
   paddingHorizontal: 11,
   paddingVertical: 29,
   borderColor: '#6D6D6D',
   borderWidth: 0.5,
   borderRadius: 13,
   marginTop:61
 },
  horizontal: {
    marginHorizontal: 14,
  },
});
